export const selectCurrentUserId = state => state.userCredentials.userId;

export const selectRootAdmin = state =>
  state.userCredentials.rootAdmin;
